import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TwinBedIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TwinBedIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.6768 16.9529H3.21973C2.94336 16.9529 2.71973 16.7293 2.71973 16.4529V11.7498C2.71973 10.9451 3.37452 10.2908 4.1792 10.2908H10.7178C11.5225 10.2908 12.1767 10.9451 12.1767 11.7498V16.4529C12.1767 16.7293 11.9531 16.9529 11.6768 16.9529ZM3.71973 15.9529H11.1768V11.7498C11.1768 11.4968 10.9707 11.2908 10.7178 11.2908H4.17921C3.92579 11.2908 3.71974 11.4968 3.71974 11.7498L3.71973 15.9529Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.6045 11.2908H4.29249C4.01612 11.2908 3.79249 11.0671 3.79249 10.7908V7.04858C3.79249 6.30542 4.39747 5.69995 5.14112 5.69995H9.75587C10.4995 5.69995 11.1045 6.30542 11.1045 7.04858V10.7908C11.1045 11.0671 10.8809 11.2908 10.6045 11.2908ZM4.79249 10.2908H10.1045V7.04858C10.1045 6.8562 9.94825 6.69995 9.75587 6.69995H5.14112C4.94874 6.69995 4.79249 6.8562 4.79249 7.04858V10.2908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.15284 11.2908H5.78516C5.50879 11.2908 5.28516 11.0671 5.28516 10.7908V8.69311C5.28516 8.18725 5.69629 7.77612 6.20215 7.77612H8.73584C9.2417 7.77612 9.65283 8.18725 9.65283 8.69311V10.7908C9.65283 11.0671 9.42921 11.2908 9.15284 11.2908ZM6.28516 10.2908H8.65284V8.77612H6.28516V10.2908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.5855 18.2986C10.3091 18.2986 10.0855 18.075 10.0855 17.7986V16.4529C10.0855 16.1765 10.3091 15.9529 10.5855 15.9529C10.8618 15.9529 11.0855 16.1765 11.0855 16.4529V17.7986C11.0855 18.075 10.8618 18.2986 10.5855 18.2986Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.31104 18.2986C4.03467 18.2986 3.81104 18.075 3.81104 17.7986V16.4529C3.81104 16.1765 4.03467 15.9529 4.31104 15.9529C4.58741 15.9529 4.81104 16.1765 4.81104 16.4529V17.7986C4.81104 18.075 4.58741 18.2986 4.31104 18.2986Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6768 15.2585H3.21973C2.94336 15.2585 2.71973 15.0349 2.71973 14.7585C2.71973 14.4822 2.94336 14.2585 3.21973 14.2585H11.6768C11.9531 14.2585 12.1768 14.4822 12.1768 14.7585C12.1768 15.0349 11.9531 15.2585 11.6768 15.2585Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.2197 16.9529H13.7627C13.4863 16.9529 13.2627 16.7293 13.2627 16.4529V11.7498C13.2627 10.9451 13.917 10.2908 14.7217 10.2908H21.2602C22.0649 10.2908 22.7197 10.9451 22.7197 11.7498V16.4529C22.7197 16.7293 22.4961 16.9529 22.2197 16.9529ZM14.2627 15.9529H21.7197V11.7498C21.7197 11.4968 21.5137 11.2908 21.2603 11.2908H14.7217C14.4688 11.2908 14.2627 11.4968 14.2627 11.7498L14.2627 15.9529Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.147 11.2908H14.835C14.5586 11.2908 14.335 11.0671 14.335 10.7908V7.04858C14.335 6.30542 14.9399 5.69995 15.6836 5.69995H20.2983C21.042 5.69995 21.647 6.30542 21.647 7.04858V10.7908C21.647 11.0671 21.4233 11.2908 21.147 11.2908ZM15.335 10.2908H20.647V7.04858C20.647 6.8562 20.4907 6.69995 20.2983 6.69995H15.6836C15.4912 6.69995 15.335 6.8562 15.335 7.04858V10.2908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.6958 11.2908H16.3276C16.0513 11.2908 15.8276 11.0671 15.8276 10.7908V8.69311C15.8276 8.18725 16.2393 7.77612 16.7451 7.77612H19.2788C19.7847 7.77612 20.1958 8.18725 20.1958 8.69311V10.7908C20.1958 11.0671 19.9722 11.2908 19.6958 11.2908ZM16.8276 10.2908H19.1958V8.77612H16.8276V10.2908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.1284 18.2986C20.852 18.2986 20.6284 18.075 20.6284 17.7986V16.4529C20.6284 16.1765 20.852 15.9529 21.1284 15.9529C21.4048 15.9529 21.6284 16.1765 21.6284 16.4529V17.7986C21.6284 18.075 21.4048 18.2986 21.1284 18.2986Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.854 18.2986C14.5776 18.2986 14.354 18.075 14.354 17.7986V16.4529C14.354 16.1765 14.5776 15.9529 14.854 15.9529C15.1304 15.9529 15.354 16.1765 15.354 16.4529V17.7986C15.354 18.075 15.1304 18.2986 14.854 18.2986Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.2197 15.2585H13.7627C13.4863 15.2585 13.2627 15.0349 13.2627 14.7585C13.2627 14.4822 13.4863 14.2585 13.7627 14.2585H22.2197C22.4961 14.2585 22.7197 14.4822 22.7197 14.7585C22.7197 15.0349 22.4961 15.2585 22.2197 15.2585Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TwinBedIcon;
